import React from 'react';
import { DownOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Dropdown, Space, Typography, Row, Col } from 'antd';

import {
  orderByTranslation,
  orderDirectionTranslation,
  orderBy,
  orderDirection,
} from 'src/utils/constants/tasks';

import { IProps } from './filter.type';
import { Wrapper } from './filter.style';
import { IReduxState } from 'src/store';
import { connect, useDispatch } from 'react-redux';
import { ItemType } from 'antd/es/menu/hooks/useItems';

const itemsOrderBy: MenuProps['items'] = orderBy.map((item) => ({
  key: item.value,
  label: item.label,
}));

const itemsOrderDirection: MenuProps['items'] = orderDirection.map((item) => ({
  key: item.value,
  label: item.label,
}));

const FilterComponent: React.FC<IProps> = (props) => {
  const { filter } = props;

  const dispatch = useDispatch();

  const handleFilter = (e: any, type: 'orderBy' | 'orderDirection') => {
    switch (type) {
      case 'orderBy':
        dispatch({
          type: 'UPDATE_TASKS_FILTER',
          payload: {
            ...filter,
            orderBy: e.key,
          },
        });

        return props.handleReload();
      case 'orderDirection':
        dispatch({
          type: 'UPDATE_TASKS_FILTER',
          payload: {
            ...filter,
            orderDirection: e.key,
          },
        });

        return props.handleReload();
      default:
        return props.handleReload();
    }
  };

  const renderFilterOptions = (
    label: string | any,
    items: ItemType[],
    type: 'orderBy' | 'orderDirection'
  ) => {
    return (
      <Dropdown
        className="my-2 p-2 d-flex justify-content-center"
        menu={{
          items,
          selectable: true,
          className: 'limit-dropdown',
          onSelect: (e) => handleFilter(e, type),
        }}
      >
        <Typography.Link
          style={{
            backgroundColor: '#eee',
            borderRadius: 2,
            color: '#4174b4',
            fontWeight: 600,
          }}
        >
          <Space>
            {label}
            <DownOutlined />
          </Space>
        </Typography.Link>
      </Dropdown>
    );
  };

  return (
    <Wrapper>
      <Row gutter={[16, 8]} wrap className="board-filters-row">
        <Col xs={24} sm={12} md={8} lg="auto">
          <p>
            Filtrando as <b>ordens de serviço</b> por:
          </p>
          {renderFilterOptions(
            orderByTranslation[filter.orderBy],
            itemsOrderBy,
            'orderBy'
          )}
        </Col>
        <Col xs={24} sm={12} md={8} lg="auto">
          <p>
            em <b>ordem:</b>
          </p>

          {renderFilterOptions(
            orderDirectionTranslation[filter.orderDirection],
            itemsOrderDirection,
            'orderDirection'
          )}
        </Col>
      </Row>
    </Wrapper>
  );
};

const mapStateToProps = (state: IReduxState) => ({
  filter: state.tasks.filter,
});

export default connect(mapStateToProps, {})(FilterComponent);
